/**
 * The entity the view is associated with.
 */
export enum ViewType {
  COMPANY = 'company',
  CONTACT = 'contact',
  PORTFOLIO = 'portfolio',
  TABS = 'teamsTabs', // Teams Tabs
}

export enum ViewCategory {
  SYSTEM,
  SHARED,
  MY,
}

export enum MappedTimeframeFilter {
  WEEK = '1Week',
  MONTH = '1Month',
  QUARTER = '3Month',
  HALF_YEAR = '6Month',
  YEAR = '1Year',
  ALL = 'All',
}

export enum ViewTimeframeFilter {
  WEEK = '1Week',
  MONTH = '1Month',
  QUARTER = '3Month',
  HALF_YEAR = '6Month',
  YEAR = '1Year',
  ALL = 'All',
  THIS_WEEK = 'thisWeek',
  LAST_WEEK = 'lastWeek',
  THIS_MONTH = 'thisMonth',
  LAST_MONTH = 'lastMonth',
  THIS_QUARTER = 'thisQuarter',
  LAST_QUARTER = 'lastQuarter',
}

export enum ViewSourceFilter {
  ALL = 'all',
  MY = 'my',
}
